document.addEventListener("DOMContentLoaded", function () {
  // Select the contact form
  const contactFormButton = document.querySelector(
    ".contact__button.form-submit"
  );
  const contactForm = document.querySelector("#ContactForm");
  

  if (contactFormButton) {
    // Add a submit event listener to the form
    contactFormButton.addEventListener("click", function (event) {
      // Prevent the form from submitting immediately
      event.preventDefault();
      let formIsValid = true;

      // Gather form data
      const input_fn =
        contactForm.querySelector('[name="FirstName"]').value || "";
      console.log(input_fn);
      const input_ln =
        contactForm.querySelector('[name="lastname"]').value || "";
      const input_email =
        contactForm.querySelector('[name="contact[email]"]').value || "";
      const input_phone =
        contactForm.querySelector('[name="contact[Phone No]"]').value || "";

      const concern = contactForm.querySelector("#ContactForm-body"); 
      const isConsentChecked = contactForm.querySelector("#consent").checked;

      const error_fn = document.getElementById("first-name-error");
      const error_email = document.getElementById("email-error");
      const error_phone = document.getElementById("phone-error");
      const error_concern = document.getElementById("concern-error");
      const error_consent = document.getElementById("consent-error");
  
      // Clear previous errors
      error_fn.textContent = "";
      error_email.textContent = "";
      error_phone.textContent = "";
      error_concern.textContent = "";
      error_consent.textContent="";

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


      const fnValue = input_fn.trim();
      if (fnValue === "") {
        error_fn.textContent = "First Name is required.";
        formIsValid = false;
      } else if (!/^[a-zA-Z\s]+$/.test(fnValue)) {
        error_fn.textContent = "First Name cannot contain numbers or special characters.";
        formIsValid = false;
      }
  
      // Email Validation
      const emailValue = input_email.trim();
      if (emailValue === "") {
        error_email.textContent = "Email is required.";
        formIsValid = false;
      } else if (!/^\S+@\S+\.\S+$/.test(emailValue)) {
        error_email.textContent = "Enter a valid email address.";
        formIsValid = false;
      }
  
      // Phone Number Validation
      const phoneValue = input_phone.trim();
      if (phoneValue === "") {
        error_phone.textContent = "Phone number is required.";
        formIsValid = false;
      } else if (!/^\d{10,12}$/.test(phoneValue)) {
        error_phone.textContent = "Enter a valid phone number (10–12 digits).";
        formIsValid = false;
      } else if (!/^[9876]/.test(phoneValue)) {
        error_phone.textContent = "Phone number must start with 9, 8, 7, or 6.";
        formIsValid = false;
      }
  
      // Concern Validation
      const concernValue = concern.value.trim();
      if (concernValue === "") {
        error_concern.textContent = "Please provide details about your concern.";
        formIsValid = false;
      }
  
      // // Consent Checkbox
      // if (!isConsentChecked) {
      //   error_consent.textContent = "Please agree to the terms and conditions."
      //   formIsValid = false;
      // }
      

      // API headers and data
      const header_value = {
        isoLanguage: "EN",
        isoCountry: "IN",
        brandCode: "BH8702",
        campaignId: "PN002392",
        campaignDescription: "Always On",
        origin: "https://lovebeautyandplanet.in/",
        formType: "signUp",
        entity: "PRM2.6",
      };

      const x_api_key = "665fb793-eb8d-42ed-85e7-31981ee4ac1a";

      const consumerIdentity = {
        firstName: input_fn,
        lastName: input_ln,
      };

      const contactDetail = {
        email: input_email,
        mobileNumber: `+91${input_phone}`,
      };

      const optInStatus = {
        legalAgeConsent: isConsentChecked,
        unileverEmailConsent: isConsentChecked,
        unileverSMSConsent: isConsentChecked,
      };

      // Prepare the request body
      const data_value = JSON.stringify({
        profile: {
          header: header_value,
          consumerIdentity,
          contactDetail,
          optInStatus,
        },
      });

      if (isConsentChecked == true) {
        // Send the form data to your API
        fetch("https://forms-sg.unileversolutions.com/v3", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": x_api_key,
          },
          body: data_value,
        })
          .then((response) => {
            if (response.ok) {
              // If the API call is successful, submit the form to Shopify
              // contactForm.submit();
            } else {
              console.error("API request failed");
              // Optionally, display an error message to the user
              // alert("Failed to submit the form. Please try again.");
              // contactForm.submit();
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            // Optionally, display an error message to the user
            // alert("An error occurred. Please try again.");
            // contactForm.submit();
          });
      }
      else {
        // contactForm.submit();
      }
      console.log(formIsValid);
      if (formIsValid == true) {
        // debugger
        contactForm.submit();
      }
    });
  }
});
